import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingService } from 'src/app/components/loading/loading.service';
import { FolderHierarchy } from 'src/app/models/folder-hierarchy.model';
import { TrimStringPipe } from 'src/app/pipes/trim-string.pipe';
import { CommonService } from 'src/app/services/common.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as SgeCrypto from 'src/assets/lib/sge/sge-crypto';
@Component({
  selector: 'app-folder-tree',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  providers: [HttpClient, TrimStringPipe],
  templateUrl: './folder-tree.component.html',
  styleUrls: ['./folder-tree.component.scss'],
})
export class FolderTreeComponent implements OnChanges {
  @ViewChildren('folder-item--selected') selectedFolders?: QueryList<ElementRef>;
  @Input() folders!: FolderHierarchy[];
  @Output() selectedFolderHiearachy = new EventEmitter<FolderHierarchy>();

  selectedFolder?: FolderHierarchy;

  constructor(public trimStringPipe: TrimStringPipe, private commonService: CommonService, public loadingService: LoadingService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.folders) {
      if (this.folders && this.folders.length > 0) {
        const folder = this.folders[0];
        if (folder && folder.parent.encrypted) {
          this.traverseFolderHierarchy(folder);
        }
      }
    }
  }

  onButtonClicked(event: Event): void {
    this.changeIconOnClick(event);
  }

  changeIconOnClick(event: Event): void {
    const icon = event.target as HTMLElement;
    if (icon.classList.contains('ti-add-plus-circle')) {
      icon.classList.remove('ti-add-plus-circle');
      icon.classList.add('ti-minus-circle');
    } else if (icon.classList.contains('ti-minus-circle')) {
      icon.classList.remove('ti-minus-circle');
      icon.classList.add('ti-add-plus-circle');
    }
  }

  selectFolder(event: Event, folder: FolderHierarchy): void {
    event.stopPropagation();
    const target = event.target as HTMLElement;

    if (target.id.toLowerCase() !== 'collapse-icon') {
      this.selectedFolder = folder;
      this.selectedFolderHiearachy.emit(this.selectedFolder);
    }
  }

  getSelectedFolderHiearachy(folder: FolderHierarchy): void {
    this.selectedFolderHiearachy.next(folder);
  }

  traverseFolderHierarchy(folder: FolderHierarchy): void {
    if (folder === null) {
      return;
    }
    this.updateAndReturnFolder(folder);
    folder.children.forEach((item) => {
      this.traverseFolderHierarchy(item);
    });
  }

  async updateAndReturnFolder(folder: FolderHierarchy): Promise<void> {
    this.loadingService.setLoading(true);

    try {
      if (folder.parent.name !== 'root') {
        if (folder.parent.encrypted) {
          const file: any = await SgeCrypto.getFolderMetadata(folder.parent.encryptedId);
          folder.parent.name = file.name;
        }
      } else {
        folder.parent.name = folder.parent.encrypted ? this.commonService.getTranslatedMessage('MY_ENCRYPTED_STORAGE') : this.commonService.getTranslatedMessage('MY_STORAGE');
      }
    } catch (error) {
    } finally {
      this.loadingService.setLoading(false);
    }
  }
}
